module.exports = __webpack_public_path__ + "static/media/title.8b9d30d6.png";